(function () {
    'use strict';

    angular
        .module('app')
        .controller('UpdateStudentPinCodeController', UpdateStudentPinCodeController);

    UpdateStudentPinCodeController.$inject = ['debug', 'API', 'i18n', '$scope', '$state', '$q',];

    function UpdateStudentPinCodeController(debug, API, i18n, $scope, $state, $q) {
        var vm = this;
        vm.cancel = $scope.$parent.cancel;
        vm.resolve = $scope.$parent.resolve;
        vm.submit = submit;
        vm.isSubmitting = false;
        vm.showDuplicatePinError = false;
        vm.newPinCode = '';

        activate();

        function activate() {
            vm.student = $scope.placeholders.student;
        }

        function checkIfPinIsAvailable(resolve, reject) {

            var classPromises = [];
            angular.forEach(vm.student.groups, function(group) {
                var classPromise = API.Group.search({
                    'expand': 'users, users.loginStudent',
                    'page': 1,
                    'per-page': 0,
                    'id': group.id,
                }).$promise;
                classPromises.push(classPromise);
            });

            $q.all(classPromises).then(function(response) {
                angular.forEach(response, function(group) {
                    angular.forEach(group.users, function(user) {
                        if (user.user_type === 'student' && user.loginStudent.pin_code === vm.newPinCode) {
                            debug.log('SAME PIN', user.loginStudent.pin_code, vm.newPinCode);
                            reject();
                        }
                    });
                });

                resolve();
            }, function() {
            });
        }

        function submit() {
            if (!vm.isSubmitting) {
                vm.isSubmitting = true;

                var pinCheckPromise = $q(function(resolve, reject) {
                    checkIfPinIsAvailable(resolve, reject);
                });

                pinCheckPromise.then(function() {
                    vm.student.loginStudent.pin_code = vm.newPinCode;
                    var promise = vm.student.$save();
                    promise.then(function () {
                        window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                        $scope.$parent.close();
                    }, function () {
                        $scope.$parent.close();
                    })
                    .finally(function() {
                        vm.isSubmitting = false;
                    });
                }, function() {
                    vm.showDuplicatePinError = true;
                    vm.isSubmitting = false;
                });
            }
        }

    }
})();